import React, {useState,useEffect} from 'react';
import {Redirect} from 'react-router-dom'//yarn add @types/react-router-dom
import useStyles from './Styles';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import DropImage from './DropImage';
import CloseIcon from '@mui/icons-material/Close';
import ColInput from './ColInput';
import Toast from './Toast';
import {Inc,Owner,Book,BookOption} from './Inc';
import {Tools} from './Tools';
import BottomButtons from './BottomButtons';
import Ajax from './Ajax';
import Loading from './Loading';
import backimage from './imgs/book_cover_back.gif';

interface Props {
    owner:Owner,
    book:Book,
    option:BookOption,
    change(book:Book,option:BookOption):void,
    close():void,
}

let errors:string[] = [];
let newImgs:{ [key: string]: string; } = {};

const BookInputCover = (props:Props)=> {
    Ajax.setEditorId(props.owner.owner_id);
    const classes = useStyles();
    const [states,setStates] = useState({
        book: Inc.defaultBook(),
        option: Inc.defaultBookOption(),
        toast:"",
        notFound: false,
        isLoading: true,
    });

    //console.log("book",props.book);
    //console.log("book_option",props.option);

    const change = (name:keyof BookOption,value:string)=>{
        if( name==="cover_img_top" || name==="cover_img_left" || name==="cover_img_width" || name==="cover_img_height" || name==="cover_title_top" || name==="cover_writer_top" ){
            if( value!=="" ){
                const v = parseInt(Tools.toHan(value));
                if( v || v===0 ){
                    setStates({...states,"option":{...states.option,[name]:v}});
                }
            } else {
                if(  name==="cover_img_width" || name==="cover_img_height" ){
                    setStates({...states,"option":{...states.option,[name]:""}});
                } else {
                    setStates({...states,"option":{...states.option,[name]:0}});
                }
            }
        } else {
            setStates({...states,"option":{...states.option,[name]:value}});
        }
    }
    const changeImage = (id:string,src:string)=>{
        if( src==="" ){
            cancelImage();
        } else {
            newImgs[ id ] = src;
            setStates({...states,option:{...states.option,cover_img_flag:"1"}});
        }
    }
    const cancelImage = ()=>{
        newImgs["img"] = "";
        setStates({...states,option:{...states.option,cover_img_flag:"0"}});
    }

    const addError = (name:keyof Book,isError:boolean) =>{
        if( isError ){
            if( !errors.includes(name) ){
                errors.push( name );
            }
        } else {
            if( errors.includes(name) ){
	    		const index = errors.findIndex((v) => v===name);
		    	errors.splice(index,1);
            }
        }
    }
    const validate = ()=>{
        let num = errors.length;
        if( num>0 ){
            setStates({ ...states, toast:"入力に不備があります"});
        } else {
            setStates({ ...states, isLoading:true});
            send();
        }
    }
    const send = ()=>{
        //let img_flag = false;
        //if( newImgs["img"] ){
        //    if( newImgs["img"]!=="" ){
                //console.log("a");
                //img_flag = true;
        //    }
        //} else if( states.book.img_id>0 ){
            //console.log("b");
            //img_flag = true;
        //}
        //console.log("img_flag",img_flag);
        Ajax.send("book/updated",{
            item_id:props.book.item_id,
            option:states.option,
            new_imgs:newImgs,
        },(res:any)=>{
            if( res.ok ){
                props.change({...states.book,img_id:res.img_id},states.option);
            } else {
                setStates({...states,toast:"エラー"});
            }
        });
    }
    const closeToast = ()=>{
        setStates({...states,toast:""});
	}


    useEffect( ()=>{
        window.scrollTo(0,0);
        newImgs = {};
        if( props.book.book_id>0 ){
            setStates({...states,book:props.book,option:props.option,isLoading:false});
        }
    },[]);

    if( states.notFound ){
        return (
            <Redirect to="/"/>
        );
    }

    if(states.isLoading){
        return (
            <Loading isLoading={true}/>
        )
    }

    const dt = new Date();
    let cover_image = "";
    if( newImgs["img"] && newImgs["img"]!=="" ){
        cover_image = newImgs["img"];
    } else {
        cover_image = process.env.REACT_APP_STOREURL + "/img/thumbnail/cover/"+String(states.book.book_id)+".jpg?t="+dt.getTime();
    }

    //image
    let image_top = 20;
    let image_left = 20;
    let image_width = "auto";
    let image_height = "auto";
    if( states.option.cover_img_top ){
        image_top += states.option.cover_img_top;
    }
    if( states.option.cover_img_left ){
        image_left += states.option.cover_img_left;
    }
    if( states.option.cover_img_width ){
        image_width = String(states.option.cover_img_width)+"px";
    } else {
        image_width = "180px";
    }
    if( states.option.cover_img_height ){
        image_height = String(states.option.cover_img_height)+"px";
    }
    const cover_image_style = {
        top: String(image_top)+"px",
        left: String(image_left)+"px",
        width: image_width,
        height: image_height,
    };

    //title
    let title_top = 20;
    let title_align:"center"|"left"|"right" = "center";
    if( states.option.cover_title_top ){
        title_top += states.option.cover_title_top;
    }
    if( states.option.cover_title_align_id ){
        if( states.option.cover_title_align_id==="R" ){
            title_align = "right";
        }
        if( states.option.cover_title_align_id==="L" ){
            title_align = "left";
        }
    }
    const cover_title_style = {
        top: String(title_top)+"px",
        textAlign: title_align,
    };

    //writer
    let writer_top = 20;
    let writer_align:"center"|"left"|"right" = "center";
    if( states.option.cover_writer_top ){
        writer_top += states.option.cover_writer_top;
    }
    if( states.option.cover_writer_align_id ){
        if( states.option.cover_writer_align_id==="R" ){
            writer_align = "right";
        }
        if( states.option.cover_writer_align_id==="L" ){
            writer_align = "left";
        }
    }
    const cover_writer_style = {
        top: String(writer_top)+"px",
        textAlign: writer_align,
    };

    //console.log("cover_image",cover_image,cover_image_style);

    return (
        <div id="book_input_cover" className={classes.modalConfirm}>
            <h3 className="bookEditor"><span>D</span>表紙</h3>
            <Grid container spacing={2} style={{marginTop:"1em"}}>
                <Grid item xs={12} sm={6}>
                    <div id="book_cover_screen" className="bookCoverScreen">
                        <div className="img" style={{backgroundImage:`URL(${backimage})`}}>
                            {states.option.cover_img_flag==="1" &&
                            <img src={cover_image} className="cover_image" style={cover_image_style}/>
                            }
                            {states.option.cover_title_flag==="1" &&
                            <div className="cover_title" style={cover_title_style}>
                                {states.book.book_name}<br/>
                                {states.book.book_name_sub!=="" &&
                                <span>{states.book.book_name_sub}</span>
                                }
                            </div>
                            }
                            {states.option.cover_writer_flag==="1" &&
                            <div className="cover_writer" style={cover_writer_style}>{props.owner.owner_name}</div>
                            }
                        </div>
                        <div className="upload">
                            {(states.option.cover_img_flag==="1" && !newImgs["img"]) ? (
                            <div style={{textAlign:"center"}}><Button variant="outlined" color="primary" onClick={cancelImage}><CloseIcon/> 画像を変更</Button></div>
                            ):(
                            <DropImage owner_id={props.owner.owner_id} img_id={0} data="" name="表紙画像" id="img" change={changeImage}/>
                            )}
                        </div>
                    </div>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <ColInput name="画像の位置" value={String(states.option.cover_img_top)} addError={addError} change={change} id="cover_img_top" type="text" startAdornment="上から" helper="12～274mm" endAdornment="mm" maxRange={274} minRange={12}/>
                        </Grid>
                        <Grid item xs={6}>
                            <ColInput name="　" value={String(states.option.cover_img_left)} addError={addError} change={change} id="cover_img_left" type="text" startAdornment="左から" helper="15～195mm" maxRange={195} minRange={15} endAdornment="mm"/>
                        </Grid>
                        <Grid item xs={6}>
                            <ColInput dense name="画像のサイズ" value={String(states.option.cover_img_width)} addError={addError} change={change} id="cover_img_width" type="text" helper="1～180mm" maxRange={180} minRange={1} startAdornment="幅" endAdornment="mm"/>
                        </Grid>
                        <Grid item xs={6}>
                            <ColInput dense name="　" value={String(states.option.cover_img_height)} addError={addError} change={change} id="cover_img_height" type="text" helper="1～274mm" maxRange={274} minRange={1} startAdornment="高さ"　endAdornment="mm"/>
                        </Grid>
                        <Grid item xs={12}>
                            <div className="bookHint">
                                幅と高さのどちらかだけ入力すると、もう一方は自動調整されます。<br/>
                                両方省略すると、最大サイズで表示されます。<br/>
                            </div>
                        </Grid>
                        <Grid item xs={12}>
                            <ColInput dense name="タイトルの表示" value={states.option.cover_title_flag} addError={addError} change={change} id="cover_title_flag" label="表示する" type="switch"/>
                        </Grid>
                        {states.option.cover_title_flag==="1" &&
                        <React.Fragment>
                        <Grid item xs={6}>
                            <ColInput dense name="タイトルの位置　" value={states.option.cover_title_align_id} addError={addError} change={change} id="cover_title_align_id" list={Inc.aligns} type="radio"/>
                        </Grid>
                        <Grid item xs={6}>
                            <ColInput name="　" value={String(states.option.cover_title_top)} addError={addError} change={change} id="cover_title_top" type="text" startAdornment="上から" helper="12～274mm" maxRange={274} minRange={12} endAdornment="mm"/>
                        </Grid>
                        </React.Fragment>
                        }
                        <Grid item xs={12}>
                            <ColInput dense name="著者名の表示" value={states.option.cover_writer_flag} addError={addError} change={change} id="cover_writer_flag" label="表示する" type="switch"/>
                        </Grid>
                        {states.option.cover_writer_flag==="1" &&
                        <React.Fragment>
                        <Grid item xs={6}>
                            <ColInput name="著者名の位置" value={states.option.cover_writer_align_id} addError={addError} change={change} id="cover_writer_align_id" list={Inc.aligns} type="radio"/>
                        </Grid>
                        <Grid item xs={6}>
                            <ColInput name="　" value={String(states.option.cover_writer_top)} addError={addError} change={change} id="cover_writer_top" type="text" startAdornment="上から" helper="12～274mm" maxRange={274} minRange={12} endAdornment="mm"/>
                        </Grid>
                        </React.Fragment>
                        }
                    </Grid>
                </Grid>
            </Grid>
			<BottomButtons button1='この内容で保存' onClick1={validate} button2='閉じる' onClick2={props.close}/>
            <Toast close={closeToast} mes={states.toast}/>
        </div>
	);
}

export default BookInputCover;
